import _ from 'underscore'
import axios from 'axios'
import React from 'react'
import { Inbox } from 'lucide-react'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import NavbarNotificationsPartial from './partial'
import LoadMore from '../../loadmore'
import store from '../../../state/store'

const VIEWS = [
  { value: 'inbox', label: 'Inbox' },
  { value: 'unopened', label: 'Unread' },
]

class NavbarNotifications extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      notifications: [],
      page: 1,
      more_results: null,
      filter: props.filter || 'inbox',
      related_to_type: '',
      search: props.search || '',
      loading: true,
      open: false
    }
  }

  componentDidMount() {
    this.onFetchData()
  }

  onFetchData = (params = {}) => {
    const getParams = _.extend({
        page: this.state.page,
        filter: this.state.filter,
        related_to_type: this.state.related_to_type,
        search: this.state.search
      },
      params
    )

    this.setState({loading: true})

    axios.get('/api/sales/notifications', {params: getParams})
    .then((response) => {
      const data = response.data
      const notifications = getParams.page === 1 ? data.notifications : this.state.notifications.concat(data.notifications)

      this.setState({
        notifications: notifications,
        more_results: data.more_results,
        page: getParams.page,
        filter: getParams.filter,
        related_to_type: getParams.related_to_type,
        search: getParams.search
      })
    })
    .catch((error) => {
      handleError(error)
    })
    .then(() => {
      this.setState({loading: false})
    })
  }

  onOpenChange = (open) => {
    if (open) {
      this.setState({open: true, notifications: []})
      this.onFetchData({filter: 'inbox', page: 1})
      store.emit('inbox:opened')
    }
    else {
      this.setState({open: false})
    }
  }

  onViewChange = (filter) => {
    this.onFetchData({filter: filter, page: 1})
  }

  onLoadMore = (page) => {
    this.onFetchData({page: page})
  }

  onOpenNotification = (notification) => {
    axios.put(`/api/sales/notifications/${notification.id}/opened`)
    .then((response) => {
      const data = response.data

      const notifications = _.map(this.state.notifications, (entry) => {
        if (entry.id === notification.id) {
          return data.notification
        }
        else {
          return entry
        }
      })

      this.setState({notifications: notifications})
    })
    .catch((error) => {
      handleError(error)
    })

    if (notification.linked_resource_type == 'Sales::Enquiry') {
      store.emit('enquiries:show', notification.linked_resource_id)
    }
    else if (notification.linked_resource_type == 'Sales::Lead') {
      store.emit('leads:show', notification.linked_resource_id)
    }
    else if (notification.link) {
      window.open(notification.link)
    }
  }

  render() {
    return (
      <Popover open={this.state.open} onOpenChange={this.onOpenChange}>
        <PopoverTrigger asChild>
          <button
            type="button"
            aria-label="Notifications"
            title="Notifications"
            className="relative flex size-9 shrink-0 items-center justify-center rounded-xl text-foreground/80 outline-hidden transition-colors hover:bg-accent hover:text-foreground data-[state=open]:bg-accent data-[state=open]:text-foreground"
          >
            <Inbox className="size-4" />
            {this.props.ui.unreads ?
              <span className="absolute -right-0.5 -top-0.5 size-2.5 rounded-full bg-destructive" />
              : null
            }
          </button>
        </PopoverTrigger>
        <PopoverContent
          side="bottom"
          align="end"
          sideOffset={8}
          className="w-[650px] max-w-[calc(100vw-2rem)] overflow-hidden p-0"
        >
          <Tabs value={this.state.filter} onValueChange={this.onViewChange} className="gap-0">
            <TabsList variant="line" className="px-2 pt-2">
              {_.map(VIEWS, (view) => {
                return (
                  <TabsTrigger key={view.value} value={view.value}>{view.label}</TabsTrigger>
                )
              })}
            </TabsList>
          </Tabs>
          <div className="max-h-[60vh] overflow-y-auto border-t">
            {(this.state.notifications.length === 0 && !this.state.loading) ?
              <p className="p-6 text-center text-sm text-muted-foreground">No notifications</p>
              :
              _.map(this.state.notifications, (notification) => {
                return (
                  <NavbarNotificationsPartial
                    key={notification.id}
                    notification={notification}
                    onOpen={this.onOpenNotification}
                  />
                )
              })
            }
            {this.state.more_results ?
              <div className="border-t px-4 py-2 text-center">
                <LoadMore
                  page={this.state.page}
                  loading={this.state.loading}
                  onLoadMore={this.onLoadMore}
                />
              </div>
              : null
            }
          </div>
        </PopoverContent>
      </Popover>
    )
  }
}

export default NavbarNotifications
